const CampaignModal = ({
  show,
  onClose,
  onSubmit,
  newCampaign,
  setNewCampaign,
  allProducts,
  handleAddProduct,
  handleProductChange,
  handleRemoveProduct,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto p-8">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 z-10"
          onClick={onClose}
        >
          ✕
        </button>
        <h3 className="text-xl font-bold mb-4">Yeni Kampanya Ekle</h3>
        <form
          onSubmit={onSubmit}
          className="flex flex-col gap-3"
        >
          <label className="font-medium">Kampanya Adı</label>
          <input type="text" name="name" placeholder="Kampanya Adı"
            value={newCampaign.name}
            onChange={e => setNewCampaign({ ...newCampaign, name: e.target.value })}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">Başlangıç Tarihi</label>
          <input type="datetime-local" name="startDate"
            value={newCampaign.startDate}
            onChange={e => setNewCampaign({ ...newCampaign, startDate: e.target.value })}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">Bitiş Tarihi</label>
          <input type="datetime-local" name="endDate"
            value={newCampaign.endDate}
            onChange={e => setNewCampaign({ ...newCampaign, endDate: e.target.value })}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">Minimum Kullanıcı</label>
          <input type="number" name="minUserCount" placeholder="Minimum Kullanıcı"
            value={newCampaign.minUserCount}
            min={0}
            onChange={e => {
              const value = Number(e.target.value);
              if (e.target.value === "" || value <= 0) return;
              setNewCampaign({ ...newCampaign, minUserCount: Number(e.target.value) })
            }}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">Minimum Toplam Sipariş</label>
          <input type="number" name="minTotalOrderQuantity" placeholder="Minimum Toplam Sipariş"
            value={newCampaign.minTotalOrderQuantity}
            min={0}
            onChange={e => {
              const value = Number(e.target.value);
              if (e.target.value === "" || value <= 0) return;
              setNewCampaign({ ...newCampaign, minTotalOrderQuantity: Number(e.target.value) })
            }}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">Maksimum Kullanıcı</label>
          <input type="number" name="maxUserCount" placeholder="Maksimum Kullanıcı"
            value={newCampaign.maxUserCount}
            min={0}
            onChange={e => {
              const value = Number(e.target.value);
              if (e.target.value === "" || value <= 0) return;
              setNewCampaign({ ...newCampaign, maxUserCount: Number(e.target.value) })
            }}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">Maksimum Toplam Sipariş</label>
          <input type="number" name="maxTotalOrderQuantity" placeholder="Maksimum Toplam Sipariş"
            value={newCampaign.maxTotalOrderQuantity}
            min={0}
            onChange={e => {
              const value = Number(e.target.value);
              if (e.target.value === "" || value <= 0) return;
              setNewCampaign({ ...newCampaign, maxTotalOrderQuantity: Number(e.target.value) })
            }}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">İndirim Oranı (%)</label>
          <input type="number" name="discountRate" placeholder="İndirim Oranı (%)"
            value={newCampaign.discountRate}
            min={0}
            max={100}
            onChange={e => {
              const value = Number(e.target.value);
              if (e.target.value === "" || value < 0 || value > 100) return;
              setNewCampaign({ ...newCampaign, discountRate: Number(e.target.value) })
            }}
            className="border rounded px-2 py-1" required />

          <label className="font-medium">Ön Ödeme Oranı (%)</label>
          <input type="number" name="depositRate" placeholder="Ön Ödeme Oranı (%)"
            value={newCampaign.depositRate}
            min={0}
            max={100}
            onChange={e => {
              const value = Number(e.target.value);
              if (e.target.value === "" || value < 0 || value > 100) return;
              setNewCampaign({ ...newCampaign, depositRate: Number(e.target.value) })
            }}
            className="border rounded px-2 py-1" required />

          <div>
            <div className="font-semibold mb-1">Kampanya Ürünleri</div>
            {newCampaign.products.map((prod, idx) => (
              <div key={idx} className="flex gap-2 mb-1">
                <label className="sr-only">Ürün</label>
                <select
                  value={prod.productId}
                  onChange={e => handleProductChange(idx, "productId", e.target.value)}
                  className="border rounded px-2 py-1"
                  required
                >
                  <option value="">Ürün Seç</option>
                  {allProducts.map(p => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                  ))}
                </select>
                <label className="sr-only">İndirimli Miktar</label>
                <input
                  type="number"
                  placeholder="İndirimli Miktar"
                  value={prod.discountedQuantity}
                  min={0}
                  onChange={e => {
                    const value = Number(e.target.value);
                    if (e.target.value === "" || value < 0) return;
                    handleProductChange(idx, "discountedQuantity", Number(e.target.value))
                  }}
                  className="border rounded px-2 py-1 w-32"
                  required
                />
                <button type="button" onClick={() => handleRemoveProduct(idx)} className="text-red-600">Sil</button>
              </div>
            ))}
            <button type="button" onClick={handleAddProduct} className="bg-green-500 text-white px-2 py-1 rounded">Ürün Ekle</button>
          </div>
          <button type="submit" className="bg-blue-600 text-white px-4 py-1 rounded hover:bg-blue-700">
            Kaydet
          </button>
        </form>
      </div>
    </div>
  );
};

export default CampaignModal;